import blockProperty from '~/utilities/blockProperty';

export default {
    methods: {
        blockPropertyObject (prop, key = false) {
            return blockProperty(prop, key);
        },
    },
};
